// LoadingScreen.js
import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import AllamSchoolLogo from '../assets/loading-logo.png'; // Adjust the path to your logo

const LoadingScreen = () => {
  return (

    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh', // Full viewport height
        backgroundColor: '#FFFFFF',
      }}
    >
            {/* Allam School Logo */}
            <img
          src={AllamSchoolLogo}
          alt="Allam School Logo"
          style={{
            height: '200px',
            width: '200px',
          }}
        /> 
      <CircularProgress size={40} sx={{ color: '#004aad' }} /> {/* Blue spinner */}
      <Typography variant="h6" sx={{ ml: 2, fontFamily: 'Fredoka One', color: '#004aad' }}>
       </Typography>
    </Box>
  );
};

export default LoadingScreen;